/** `error_type` public-api returns when it blocks on an outstanding document. */
export const ATTESTATION_REQUIRED_ERROR_TYPE = 'attestation_required'

/**
 * Recognises public-api's attestation rejection by its `error_type` rather
 * than by the bare 403, which every other permission failure also returns.
 */
export function isAttestationRequired(
  body: unknown,
): body is { error_type: typeof ATTESTATION_REQUIRED_ERROR_TYPE } {
  return (
    typeof body === 'object' &&
    body !== null &&
    'error_type' in body &&
    body.error_type === ATTESTATION_REQUIRED_ERROR_TYPE
  )
}

/**
 * Shown in place of the assistant's turn. `useAttestationGate` fails open —
 * flag off, pending-list request in flight or failed — so the reopened dialog
 * cannot be relied on as the only feedback.
 */
export const ATTESTATION_REQUIRED_MESSAGE =
  'You need to accept the terms of use before the assistant can respond.'

/** Carries the rejection to the stream hooks' catch. */
export class AttestationRequiredError extends Error {
  constructor() {
    super(ATTESTATION_REQUIRED_MESSAGE)
    this.name = 'AttestationRequiredError'
  }
}
